<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="props.title">
    <template v-slot:modalBody>
      <span>
        {{ props.content }}
      </span>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        v-if="props.on_close"
        variant="primary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';

  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      title: string;
      content: string;
      class?: string;
    }>(),
    {
      class: ''
    }
  );
</script>

<style lang="scss" scoped></style>
